/* eslint-disable camelcase */
import {signUpGetStartedEvent} from '../segment'

angular.module('app.ui.form.ctrls').controller('SignUpController', [
  '$window',
  'logger',
  '$route',
  '$rootScope',
  'SignUpApi',
  'api',
  'userService',
  '$scope',
  function controller(
    $window,
    logger,
    $route,
    $rootScope,
    SignUpApi,
    api,
    userService,
    $scope
  ) {
    let vm = this

    vm.notify = (type, message) => {
      switch (type) {
        case 'info':
          logger.log(message)
          break
        case 'success':
          logger.logSuccess(message)
          break
        case 'warning':
          logger.logWarning(message)
          break
        case 'error':
          logger.logError(message)
          break
        default:
          break
      }
    }

    vm.hideDropDown = () => {
      vm.showClass = ''
    }

    vm.user = {
      referralId: '',
    }
    if ($route.current.params.referralCode) {
      $rootScope.referralCode = $route.current.params.referralCode
    }

    if ($rootScope.referralCode !== '') {
      vm.user.referralId = $rootScope.referralCode
    }

    vm.pattern = /^[a-z]+ [A-Z]+ [\d._a-z]+@[a-z]+\.[.a-z]{2,5}$/
    vm.getParameterByName = name => {
      var regex
      var results
      name = name.replace(/\[/, '\\[').replace(/]/, '\\]')
      regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      results = regex.exec($window.location.href)
      if (results === null) {
        return ''
      }

      return decodeURIComponent(results[1].replace(/\+/g, ' '))
    }

    vm.showOnError = false
    vm.alertMsg = ' '
    vm.showClass = ''
    vm.showDropDown = () => {
      if (vm.showClass === '') {
        vm.showClass = 'show'
      } else {
        vm.showClass = ''
      }
    }

    vm.showEmailInvalid = false
    vm.validateEmail = event => {
      var index
      index = event.target.attributes.class.value.search(' ng-invalid ')
      if (index >= 0) {
        vm.notify('error', 'Please enter a valid email address.')
      }
    }

    const isEmailValid = email => {
      const result =
        email &&
        email.length &&
        email.length > 2 &&
        email.includes('@') &&
        email.indexOf('@') > 0
      vm.showEmailInvalid = !result
      return result
    }

    vm.changeStatus = status => {
      console.debug('vm.changeStatus', status)
      if (typeof status === 'string') {
        vm.alertMsg =
          status === 'ERR_BAD_REQUEST'
            ? 'Invalid email detected. Is this email already in use? Please get in contact if you believe this is a mistake.'
            : vm.capitalize(status)
        vm.showOnError = true
        vm.showEmailInvalid = status === 'ERR_BAD_REQUEST'

        vm.notify('error', status)
      } else if (status === 404) {
        vm.showOnError = true
        vm.alertMsg = 'Error! Passwords do not match. Please try again.'
        vm.notify('error', 'Error! Passwords do not match. Please try again.')
      } else if (status === 400) {
        vm.showOnError = true

        vm.alertMsg = 'Error! Emails do not match. Please try again.'
        vm.notify('error', 'Error! Emails do not match. Please try again.')
      } else if (status === 401) {
        vm.showEmailInvalid = true
        vm.notify(
          'error',
          'Email is invalid. Please enter a valid email address.'
        )
      } else if (status === 500) {
        vm.showOnError = true
        vm.alertMsg = 'Could not connect to the server. Please try again later.'
        vm.notify(
          'error',
          'Could not connect to the server. Please try again later.'
        )
      } else if (status === 300) {
        vm.showOnError = true
        vm.alertMsg =
          'Please agree to the terms & conditions and privacy policy of LexStep before you get started.'
        vm.notify(
          'error',
          'Please agree to the terms & conditions and privacy policy of LexStep before you get started.'
        )
      } else if (status >= 401 && status < 500) {
        vm.showOnError = true
        vm.alertMsg =
          'Unable to sign up. Is this email already registered with us?'
        vm.notify('error', vm.alertMsg)
      } else {
        vm.showOnError = true
        vm.alertMsg = 'An error has occurred. Please try the action again.'
        vm.notify(
          'error',
          'An error has occurred. Please try the action again.'
        )
      }
    }

    vm.capitalize = string => {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }

    vm.AddLawyer = async () => {
      const signUpData = Object.assign(
        {
          email: vm.user.email,
          password: vm.user.password,
          firstName: vm.user.firstName,
          lastName: vm.user.lastName,
          professions: ['law'],
        },
        vm.user.referralId && {referralId: vm.user.referralId}
      )

      vm.disableSignupBtnClass = true

      if (!isEmailValid(vm.user.email)) {
        vm.disableSignupBtnClass = false
        return vm.changeStatus(401)
      }

      if (vm.user.password.length >= 6) {
        vm.showOnError = false
        try {
          const response = await SignUpApi.signUp(signUpData)
          console.debug('sign up response', response)
          const data = response.data
          vm.idToken = data.tokenResponse.id_token
          api.startSession(data.tokenResponse)
          const user = await userService.setUser(data.user)
          $window.localStorage.setItem('signIn', Date.now())
          signUpGetStartedEvent()
          try {
            analytics.identify(data.user.id, {
              first_Name: data.user.firstName,
              last_Name: data.user.lastName,
              email: data.user.email,
            })
          } catch (error) {
            console.error('Sign Up', error)
          }

          $window.location.href = user.defaultRoute
        } catch (error) {
          console.error('sign up error', error)

          if (error && error.data && error.data.message) {
            vm.changeStatus(error.data.message)
          } else if (error && error.status) {
            vm.changeStatus(error.status)
          } else if (error && error.code) {
            vm.changeStatus(error.code)
          }

          vm.disableSignupBtnClass = false
          $scope.$apply()
        }
      } else {
        vm.disableSignupBtnClass = false
        vm.notify('error', 'Error! Password must be at least 6 characters.')
        $scope.$apply()
      }
    }
  },
])



// WEBPACK FOOTER //
// ./scripts/sign-up/sign-up.ctrl.js